<template>
  <span class="checkout-tag content-ellipsis" :class="{ active, dark }">
    <slot></slot>
  </span>
</template>

<script>
  export default {
    name: 'checkout-tag',
    props: {
      active: Boolean,
      dark: Boolean
    }
  }
</script>

<style lang="scss" scoped>
  @use '~stylesheets/meta.scss' as *;
  @use '~stylesheets/base.scss' as *;

  $tag-height: 24px;

  .checkout-tag {
    height: $tag-height;
    padding: 0 13px;
    display: inline-block;
    border-radius: 30px;
    background-color: $color-grey;
    transition: .3s $transition-ease-out;
    color: $color-brown-grey;
    line-height: $tag-height;
  }

  .active {
    background-color: $color-dark-grey;
    color: #fff;
  }

  .dark {
    background-color: #606060;
    color: #fff;

    &.active {
      background-color: #21282a;
    }
  }
</style>
